import { render, staticRenderFns } from "./MailFilters.vue?vue&type=template&id=6cfc9d15"
import script from "./MailFilters.vue?vue&type=script&lang=js"
export * from "./MailFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports